import request from '../../axios/axiosconfig.js'

/**
 * 查询用户列表
 * @param {*} params 
 * @returns 
 */
 export function userList(params) {
    return request({
      url: '/ps/userList/getAllUser',
      method: 'get',
      params: params,
      timeout: 100000
    })
  }


// WEBPACK FOOTER //
// ./src/api/usermanagement/usList.js